import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { AppState } from 'mk2/reducers';
import React from 'react';
import { connect } from 'react-redux';
import { deletionExecute, deletionHideForm } from './Deletion.actions';
import { generateFormName } from './Deletion.helpers';
import { DeletionsState } from './Deletion.reducers';
import { DeletionTargetType } from './Deletion.schemas';
import { getDeletionsState, getDeletionShownForTarget } from './Deletion.selectors';
import { DeletionFormData, DeletionFormFactory } from './DeletionForm';

interface OwnProps {
    className?: string;
    entity: DeletionTargetType;
    id: number;
    scrollOffset?: number; // When deletion is displayed we are scrolling him into view - this can be used to add some offset
}

interface StateProps {
    show: boolean;
}

interface DispatchProps {
    onCancel(entity: string, id: number);
    onExecute(entity: string, id: number, deletion: DeletionFormData);
}

type Props = OwnProps & StateProps & DispatchProps;

/**
 * Split form vs container - inject form to the page only if 'show' is true or it will re-render with every state change
 */
class Deletion extends React.Component<Props> {

    private DeletionForm = DeletionFormFactory(generateFormName(this.props.entity, this.props.id));

    public render() {
        const { className, entity, id, onCancel, onExecute, scrollOffset, show } = this.props;
        const DeletionForm = this.DeletionForm;

        return show ? (
            <DeletionForm
                className={className}
                entity={entity}
                id={id}
                scrollOffset={scrollOffset}
                onCancel={onCancel}
                onExecute={onExecute}
            />
        ) : null;
    }
}

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    const complaitsState: DeletionsState  = getDeletionsState(state);

    return {
        show: getDeletionShownForTarget(complaitsState, ownProps.entity, ownProps.id),
    };
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {
    onCancel: (entity, id) => deletionHideForm(entity, id),
    onExecute: deletionExecute,
};

export default connect(mapStateToProps, mapDispatchToProps)(Deletion);
